import { render, staticRenderFns } from "./shop-default.vue?vue&type=template&id=088e6dd2&scoped=true"
import script from "./shop-default.vue?vue&type=script&lang=js"
export * from "./shop-default.vue?vue&type=script&lang=js"
import style0 from "./shop-default.vue?vue&type=style&index=0&id=088e6dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e6dd2",
  null
  
)

export default component.exports